/**
 * Devuelve la URL sólo si el protocolo es seguro (http/https, y mailto cuando
 * se permite). Cualquier otro valor se descarta.
 */
export function safeUrl(
  value: string | undefined,
  allowMailto = false
): string | null {
  if (!value) return null

  try {
    const base =
      typeof window === 'undefined' ? 'https://localhost' : window.location.href
    const url = new URL(value, base)

    if (url.protocol === 'http:' || url.protocol === 'https:') return url.href
    if (allowMailto && url.protocol === 'mailto:') return url.href
    return null
  } catch {
    return null
  }
}
